import type { RouteRecordRaw } from 'vue-router'

/** 营销活动域路由配置 */
export function getMarketingRoutes(): RouteRecordRaw[] {
  return [
    {
      path: '/marketing-page/preview',
      name: 'MarketingPagePreview',
      component: () => import('./views/preview.vue'),
      meta: { title: '活动预览' }
    },
    {
      path: '/marketing-page/fallback',
      name: 'MarketingPageFallback',
      component: () => import('./views/fallback.vue'),
      meta: { title: '活动暂未开始' }
    },
    {
      path: '/login-v2',
      name: 'MarketingLoginV2',
      component: () => import('./views/login/auth.vue'),
      meta: { title: '登录' }
    },
    {
      path: '/marketing-page/:id',
      name: 'MarketingPage',
      component: () => import('./views/index.vue'),
      meta: { title: '活动' }
    }
  ]
}
